// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.helpPageBody__j52nh {
  padding: 0 25px 25px 25px;
  display: flex;
  flex-direction: column;
}
@media (max-width: 800px) {
  .helpPageBody__j52nh {
    padding: 0 15px 15px 15px;
  }
}

.sectionTitle__iuXqM {
  margin-top: 25px;
  margin-bottom: 10px;
  color: var(--title-inputs-sections-title);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
}
@media (max-width: 800px) {
  .sectionTitle__iuXqM {
    margin-top: 15px;
  }
}

.sectionApps__Yi2DY {
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  width: 100%;
}
@media (max-width: 800px) {
  .sectionApps__Yi2DY {
    gap: 15px;
  }
}

.sectionOthers__qBpjO,
.sectionTeam__Jsom0,
.sectionSupportResources___OXRj {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 25px;
  width: 100%;
}
@media (max-width: 1280px) {
  .sectionOthers__qBpjO,
  .sectionTeam__Jsom0,
  .sectionSupportResources___OXRj {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 1024px) {
  .sectionOthers__qBpjO,
  .sectionTeam__Jsom0,
  .sectionSupportResources___OXRj {
    grid-template-columns: repeat(1, 1fr);
  }
}
@media (max-width: 800px) {
  .sectionOthers__qBpjO,
  .sectionTeam__Jsom0,
  .sectionSupportResources___OXRj {
    gap: 15px;
  }
}

.questionCard__KL_b3 {
  background: var(--tables-primary-row-surface-default);
  border: 1px solid var(--header-stroke);
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.questionCardInfo__SPrlI {
  padding: 25px 25px 0;
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.questionCardTitle__IcZP6 {
  color: var(--tables-primary-row-text-main);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  text-transform: uppercase;
  margin: unset;
}

.questionCardDesc__EXqti {
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin: unset;
}

.questionCardFooter__oyHh7 {
  border-top: 1px solid var(--tables-primary-row-stroke);
  padding: 15px 25px;
  display: flex;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./../src/pages/HelpAndResources/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,yBAAA;EACA,aAAA;EACA,sBAAA;AAzEF;AA2EE;EALF;IAMI,yBAAA;EAxEF;AACF;;AA2EA;EACE,gBAAA;EACA,mBAAA;EACA,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAxEF;AA0EE;EAVF;IAWI,gBAAA;EAvEF;AACF;;AA0EA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;AAvEF;AAyEE;EANF;IAOI,SAAA;EAtEF;AACF;;AAyEA;;;EAGE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,WAAA;AAtEF;AAwEE;EARF;;;IASI,qCAAA;EAnEF;AACF;AAqEE;EAZF;;;IAaI,qCAAA;EAhEF;AACF;AAkEE;EAhBF;;;IAiBI,SAAA;EA7DF;AACF;;AAgEA;EACE,qDAAA;EACA,sCAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA7DF;;AAgEA;EACE,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA7DF;;AAgEA;EACE,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;AA7DF;;AAgEA;EACE,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;AA7DF;;AAgEA;EACE,sDAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;AA7DF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.helpPageBody {\n  padding: 0 25px 25px 25px;\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 800px) {\n    padding: 0 15px 15px 15px;\n  }\n}\n\n.sectionTitle {\n  margin-top: 25px;\n  margin-bottom: 10px;\n  color: var(--title-inputs-sections-title);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n\n  @media (max-width: 800px) {\n    margin-top: 15px;\n  }\n}\n\n.sectionApps {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 25px;\n  width: 100%;\n\n  @media (max-width: 800px) {\n    gap: 15px;\n  }\n}\n\n.sectionOthers,\n.sectionTeam,\n.sectionSupportResources {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 25px;\n  width: 100%;\n\n  @media (max-width: 1280px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  @media (max-width: 1024px) {\n    grid-template-columns: repeat(1, 1fr);\n  }\n\n  @media (max-width: 800px) {\n    gap: 15px;\n  }\n}\n\n.questionCard {\n  background: var(--tables-primary-row-surface-default);\n  border: 1px solid var(--header-stroke);\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.questionCardInfo {\n  padding: 25px 25px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n}\n\n.questionCardTitle {\n  color: var(--tables-primary-row-text-main);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n  text-transform: uppercase;\n  margin: unset;\n}\n\n.questionCardDesc {\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  margin: unset;\n}\n\n.questionCardFooter {\n  border-top: 1px solid var(--tables-primary-row-stroke);\n  padding: 15px 25px;\n  display: flex;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpPageBody": `helpPageBody__j52nh`,
	"sectionTitle": `sectionTitle__iuXqM`,
	"sectionApps": `sectionApps__Yi2DY`,
	"sectionOthers": `sectionOthers__qBpjO`,
	"sectionTeam": `sectionTeam__Jsom0`,
	"sectionSupportResources": `sectionSupportResources___OXRj`,
	"questionCard": `questionCard__KL_b3`,
	"questionCardInfo": `questionCardInfo__SPrlI`,
	"questionCardTitle": `questionCardTitle__IcZP6`,
	"questionCardDesc": `questionCardDesc__EXqti`,
	"questionCardFooter": `questionCardFooter__oyHh7`
};
module.exports = ___CSS_LOADER_EXPORT___;
